import type { SceneSettingsData } from '../core/SceneSettingsData';

type MapPresentationSettings = Pick<
    SceneSettingsData,
    | 'showProcessCurve'
    | 'showProcessNumbers'
    | 'showProcessMarkerSpheres'
    | 'showProcessStartMarker'
    | 'showMorphline'
>;

/**
 * Kartenmarker sind keine lineare Presenter-Story. Beide Map-Renderer müssen
 * deshalb den generischen Präsentationspfad explizit unterdrücken — auch wenn
 * persistierte Einstellungen ihn zuvor aktiviert hatten.
 */
export function configureMapPresentationSettings(settings: MapPresentationSettings): void {
    settings.showProcessCurve.value = false;
    settings.showProcessNumbers.value = false;
    settings.showProcessMarkerSpheres.value = false;
    settings.showProcessStartMarker.value = false;
    settings.showMorphline.value = false;
}
